
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.5 7l.5-2h-4l1-4h-2l-1 4H8l1-4H7L6 5H2l-.5 2h4l-1 4h-4L0 13h4l-1 4h2l1-4h4l-1 4h2l1-4h4l.5-2h-4l1-4zm-7 4h-4l1-4h4z"}})])
          )
        }
      }
    